import { render, staticRenderFns } from "./PuzzleListTable.vue?vue&type=template&id=be26bec2&scoped=true&lang=html"
import script from "./PuzzleListTable.vue?vue&type=script&lang=js"
export * from "./PuzzleListTable.vue?vue&type=script&lang=js"
import style0 from "./PuzzleListTable.vue?vue&type=style&index=0&id=be26bec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be26bec2",
  null
  
)

export default component.exports